import { createApp, defineAsyncComponent } from 'vue';
import { i18n } from '../../setup/i18n';
import emitter from '../../setup/bus';

export default function initDocumentDownloadApproval() {
    const app = createApp({});
    app.config.globalProperties.$bus = emitter;
    app.provide('$bus', emitter);
    app.use(i18n)
        .component(
            'DocumentDownloadApproval',
            defineAsyncComponent(() => import('./DocumentDownloadApproval.vue'))
        )
        .mount('#app-document-download-approval');
}
